<template>
  <div class="memory-pads">
    <memory-pad
      v-for="memoryPad in memory"
      :memoryNr="memoryPad"
      :key="memoryPad"
    />
  </div>
</template>

<script>
import MemoryPad from "@/components/MemoryPad.vue";

export default {
  name: "MemoryPads",
  components: {
    MemoryPad
  },
  computed: {
    memory() {
      return this.$store.getters.memoryPads;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../partials/vars";

.memory-pads {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 640px;
}
</style>
